import React from 'react';
import './ErrorModal.css';

export default function ErrorModal({ error, onClose }) {
  if (!error) return null;

  const { error: title, message, statusCode } = error;

  return (
    <div className="modal-backdrop">
      <div className="modal">

        <div className="modal-header">
          <h3>{title || 'Error'}</h3>
          <span className="status">HTTP {statusCode}</span>
        </div>

        <div className="modal-body">
          <p>{message || 'Unexpected error occurred.'}</p>
        </div>

        <div className="modal-footer">
          <button onClick={onClose}>OK</button>
        </div>

      </div>
    </div>
  );
}
